import {Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import CheckoutLayout from "./layouts/CheckoutLayout";
import All from './pages/all'
import Privacy from "./pages/privacy";
import Use from "./pages/use";
import Reimbursement from "./pages/Reimbursement";
import Checkout from "./pages/checkout";
import './App.css';

function App() {
  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<All />}/>
          <Route path="/privacypolicy" element={<Privacy />}/>
          <Route path="/termsandconditions" element={<Use />}/>
          <Route path="/refundpolicy" element={<Reimbursement />}/>
        </Route>
        <Route element={<CheckoutLayout />}>
          <Route path="/checkout" element={<Checkout />}/>
        </Route>
      </Routes>
    </>
  );
}

export default App;
